import { PaymentMethodGrid } from "./payment-methods/PaymentMethodGrid";
import { usePaymentMethods } from "./hooks/usePaymentMethods";
import { PaymentSummary } from "./types/PaymentTypes";
import { TotalAmount } from "./TotalAmount";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { startOfDay, endOfDay } from "date-fns";

interface PaymentMethodSummaryProps {
  summaries: PaymentSummary[];
  onCountedChange: (method: string, value: string) => void;
  period: string;
}

export const PaymentMethodSummary = ({
  summaries,
  onCountedChange,
  period,
}: PaymentMethodSummaryProps) => {
  const { completeSummaries, visibleMethods, expandedMethods, toggleDetails } = usePaymentMethods(summaries);

  const { data: validatedAmounts = [], isLoading } = useQuery({
    queryKey: ["validatedAmounts", "today"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user?.id) {
        console.log("No user found");
        return [];
      }

      const today = new Date();
      const startDate = startOfDay(today).toISOString();
      const endDate = endOfDay(today).toISOString();

      console.log("Fetching validated amounts for today:", { startDate, endDate });

      const { data, error } = await supabase
        .from("validated_amounts")
        .select("*")
        .eq("owner_id", user.id)
        .eq("status", "validated")
        .gte("created_at", startDate)
        .lte("created_at", endDate)
        .order('created_at', { ascending: false });

      if (error) {
        console.error("Error fetching validated amounts:", error);
        return [];
      }

      console.log("Validated amounts found:", data);
      return data || [];
    },
    refetchInterval: 30000, // Rafraîchir toutes les 30 secondes
    staleTime: 0,
    gcTime: 0,
  });

  const validatedTotal = validatedAmounts.reduce((sum, record) => sum + record.amount, 0);

  return (
    <div className="space-y-6">
      {validatedTotal > 0 && (
        <TotalAmount
          amount={0}
          counted={validatedTotal}
          period={period}
        />
      )}
      <PaymentMethodGrid
        summaries={completeSummaries}
        visibleMethods={visibleMethods}
        expandedMethods={expandedMethods}
        onCountedChange={onCountedChange}
        onToggleExpand={toggleDetails}
      />
    </div>
  );
};